// Module
var code = "<h1 class=\"heading\" translate>Downloading your XML export...</h1> <p>Your export is downloading, this may take some time.</p> ";
// Exports
module.exports = code;